import type { RouteRecordRaw } from 'vue-router'
import { prefixRoutes, route } from '@/router/utils'
import type { Options } from '@/router'
import { i18n } from '@/i18n'

import { receiveRoute } from '@m/cabinet/components/views/utils'
import { companyApi } from '@/services/company.service'
import Receive from '@m/cabinet/components/views/Receive.vue'
import { path } from 'ramda'

export const BILLING_PREFIX = 'cabinet:billing'
const p = (name: string) => BILLING_PREFIX + ':' + name

export const BILLING_INVOICE_VIEW_NAME = p('invoice')
export const BILLING_TRANSACTION_VIEW_NAME = p('transaction')

const InvoicesListView = () =>
  import('@m/cabinet/modules/Billing/InvoicesList.vue')
const TransactionsListView = () =>
  import('@m/cabinet/modules/Billing/TransactionsList.vue')

const BASE_MODEL_PATH = 'billing/'

export function createRoutes(options: Options): RouteRecordRaw[] {
  const { t: $t } = i18n.global

  return [
    prefixRoutes(
      ':chainId/',
      [
        route('invoice/', InvoicesListView, BILLING_INVOICE_VIEW_NAME, {
          meta: {
            title: () => $t('Invoices as transactions'),
            isHideCabinetHead: true,
          },
        }),
        route('transaction/', TransactionsListView, BILLING_TRANSACTION_VIEW_NAME, {
          meta: {
            title: () => $t('Transaction'),
          },
        }),
      ],
      {
        ...options,
        name: BILLING_PREFIX,
        redirect: { name: BILLING_TRANSACTION_VIEW_NAME },
      }
    ),
  ]
}

export { BASE_MODEL_PATH }
